<template>
    <div class="w100 bgWhite" style="min-height: 550px;">
        <article class="wContent center" style="padding-top: 20px">
            <!-- 广告 start -->
            <div v-if="adIDsIndex[0]['list']" style="margin-bottom: 20px;">
                <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: -10px; margin-bottom: -10px;">
                    <img :src="item.adPicturePath" alt="" class="w100">
                </a>
            </div>
            <!-- 广告 end -->
            <ul class="w100 trade-varieties-box" v-show="varietiesList.length > 0">
                <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter" :class="{'active': varietiesType == ''}" @click="changeType('')">全部</a></li>
                <li v-for="(item, index) in varietiesList" :key="index"><a href="javascript:;" :class="{'active': varietiesType == item.id}" class="ellipsis block fontNormal fontBold font14 textCenter" @click="changeType(item.id)">{{ item.name }}</a></li>
                <!-- <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter">热卷</a></li>
                <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter">冷轧板</a></li> -->
                <!-- <li><a href="javascript:;" class="block fontNormal fontBold font14 textCenter" style="margin-right: -1px;" @click="changeType('other')">其他</a></li> -->
            </ul>
            <!-- 关键字搜索 start -->
            <div class="textRight w100" style="padding-top: 20px" v-show="varietiesList.length > 0">
                <div class="quote-key-input inlineBlock">
                    <el-input placeholder="请输入内容" v-model="searchKey">
                        <template slot="append">
                            <a href="javascript:;"  @click="search(1)" class="fontWhite">搜索</a>
                        </template>
                    </el-input>
                </div>
                <el-button type="primary" class="bgRed" style="margin-left: 20px; border: 0" @click="addTradeNews">我要发布商情</el-button>
            </div>
            <!-- 关键字搜索 end -->

            <!-- 商情列表 start -->
            <div style="margin-top: 20px;" v-show="!none">
                <el-row :gutter="20">
                    <el-col :span="8" v-for="(item, index) in tableList" :key="index">
                        <div class="trade-list-box w100">
                            <span class="recommend-status" v-show="item.enterpriseInfo.recommendStatus"></span>
                            <div class="top">
                                <h4 @click="goDetail(item.user.userPhone)" class="pointer">
                                    <a class="ellipsis inlineBlock vMid" style="max-width: 230px" :title="item.enterpriseInfo.name">{{ item.enterpriseInfo.name }}</a>
                                    <span class="font14 fontLight">{{ item.createTime.substr(0, 10) }}</span>
                                </h4>
                                <div class="inlineBlock trade-product-btn" style="height: 38px;">
                                    <span v-for="(cItem, cIndex) in item.enterpriseInfo.varieties" :key="cIndex"><el-button size="mini" v-if="cIndex < 3">{{ cItem.name }}</el-button></span>
                                </div>
                            </div>
                            <div class="bgGrey middle fontNormal font14">
                                <p>{{ item.content }}</p>
                            </div>
                            <div class="bottom">
                                <p class="fontRed font14 fontBold w100 ellipsis" :title="item.enterpriseInfo.address"><i class="el-icon-location font16"></i> {{ item.enterpriseInfo.address }}</p>
                                <p class="fontRed font14 fontBold"><i class="el-icon-phone-outline font16"></i> {{ item.enterpriseInfo.phone }}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 商情列表 end -->

            <!-- 分页 start -->
            <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;" v-show="!none">
                <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
            </div>
            <!-- 分页 end -->

            <div class="textCenter font16 fontNormal" style="padding-top: 20px;" v-show="none">暂无商情信息~</div>
        </article>
        <Login ref="loginDialog"></Login>
    </div>
</template>
<script>
import $ from 'jquery'
import Login from '../../templates/loginControl'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
export default {
    name: 'TradeNews',
    components: { Login },
    data() {
        return {
            searchKey: '',
            tableList: [],
            varietiesList: [],
            varietiesType: '',
            pageNo: 1,
            pageSize: 12,
            totalnum: 0,
            adIDsIndex: [{
                name: 'qysq',
                id: adIDs['qysq'],
                list: []
            }],
            none: false
        }
    },
    mounted () {
        this.varietiesType = getQueryString('type') ? getQueryString('type') : '';
        this.getAdByAdp();
        this.findAll();
        this.search()
    },
    methods: {
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
        // 查询全部的产品分类
        findAll () {
            const self = this;
            self.$get(`${baseUrl.business}/api/varieties/findAll`, {}).then(res => {
                if (res.status == 200) {
                    self.varietiesList = res.data;
                } else {
                    self.$message.error(res.msg);
                }
            })
        },
        // 切换产品类型
        changeType (type) {
            this.varietiesType = type;
            this.search(1)
        },
        // 根据条件查询全部已审核的商情列表
        search (type) {
            const self = this;
            if (type) {
                self.pageNo = 1;
                self.searchKey = self.searchKey.replace(/\s*/g,"");
            }
            self.$post(`${baseUrl.business}/api/businessInfo/showAll/${self.pageNo - 1}/${self.pageSize}`, {searchKey: self.searchKey, varietiesId: self.varietiesType}).then(res => {
                if (res.status == 200) {
                    if (res.data.content.length > 0) {
                        self.tableList = res.data.content;
                        self.totalnum = res.data.totalElements;
                        self.none = false;
                    } else {
                        self.none = true;
                    }
                } else {
                    self.$message.error(res.msg);
                }
            })
        },

        // 切换分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.search();
        },


        // 跳转到详情页
        goDetail (phone) {
            let routeUrl = this.$router.resolve({
                path: `/home/tradeDetail?id=${phone}`
            });
            window.open(routeUrl .href, '_blank');
            // this.$router.push(`/home/tradeDetail?id=${phone}`)
        },
        addTradeNews () {
            if (this.$cookies.get('token_cyw')) {
                this.$router.push(`/home/selfPage?type=发布商情`);
            } else {
                this.$refs.loginDialog.init();
            }
        },
        
    }
    
}
</script>

<style scoped>
    .trade-varieties-box { display: flex; border: 1px solid #e0e0e0; padding: 0; margin: 0; box-sizing: border-box; }
    .trade-varieties-box > li { flex: 1; width: 100% }
    .trade-varieties-box > li > a { line-height: 40px; background: #DCDFE6; box-sizing: border-box; }
    .trade-varieties-box > li > a.active { background: #fff; color: #a30000 !important; border-right: 1px solid #c0c4cc; }
    
    .trade-product-btn .el-button--mini,
    .trade-product-btn .el-button--mini:hover { 
        border-color: #a30000; 
        color: #a30000; 
        background: #fff; 
        margin-left: 0; 
        margin-right: 10px; 
        margin-bottom: 10px;
        line-height: 0.7;
        padding: 7px 10px;
    }
    .trade-list-box { height: 270px; border: 1px solid #909399; box-shadow: 3px 3px 2px #DCDFE6; border-radius: 5px; padding-top: 10px; padding-bottom: 10px; margin-bottom: 20px; position: relative; }
    .trade-list-box .recommend-status { position: absolute; top: 0; left: 0; width: 40px; height: 40px; background: url('../../assets/images/trade_tuijian.png') no-repeat; background-size: 100% 100%; }
    .trade-list-box .middle,
    .trade-list-box .top,
    .trade-list-box .bottom { padding: 0 20px 0 35px; }
    .trade-list-box .middle p { line-height: 35px; }
    .trade-list-box .middle {
        /* display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6; */
        overflow-y: auto;
        height: 105px;
    }
    .trade-list-box .top h4 { font-size: 16px; font-weight: bold; line-height: 50px; }
    .trade-list-box .top h4 span { float: right; font-weight: 400; margin-top: 2px; }
    .trade-list-box .bottom p { line-height: 35px; }
</style>